import React from 'react';
import AboutUsContents from './AboutUsContents';
import Newsletter from '../component/Newsletter';
import BrandLogos from '../component/BrandLogos';
import DynamicTestimonials from './DynamicTestimonials';

const AboutUs = () => {
  return (
    <>
      <main class="main__content_wrapper">
        <section class="breadcrumb__section breadcrumb__bg">
          <div class="container">
            <div class="row row-cols-1">
              <div class="col">
                <div class="breadcrumb__content">
                  <h1 class="breadcrumb__content--title text-white mb-10">
                    About Us
                  </h1>
                  <ul class="breadcrumb__content--menu d-flex">
                    <li class="breadcrumb__content--menu__items">
                      <a class="text-white" href="index.html">
                        Home
                      </a>
                    </li>
                    <li class="breadcrumb__content--menu__items">
                      <span class="text-white">About Us</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <AboutUsContents />
        <div
          class="counterup__banner--section counterup__banner__bg2"
          id="funfactId"
        >
          <div class="container">
            <div class="row row-cols-1 align-items-center">
              <div class="col">
                <div class="counterup__banner--inner position__relative d-flex align-items-center justify-content-between">
                  <div class="counterup__banner--items text-center">
                    <p class="counterup__banner--items__text text-white">
                      YEARS OF <br />
                      FOUNDATION
                    </p>
                    <span
                      class="counterup__banner--items__number js-counter text-white"
                      data-count="50"
                    >
                      15<sup>+</sup>
                    </span>
                  </div>
                  <div class="counterup__banner--items text-center">
                    <p class="counterup__banner--items__text text-white">
                      SKILLED TEAM <br />
                      MEMBERS
                    </p>
                    <span
                      class="counterup__banner--items__number js-counter text-white"
                      data-count="100"
                    >
                      300
                    </span>
                  </div>
                  <div class="counterup__banner--items text-center">
                    <p class="counterup__banner--items__text text-white">
                      HAPPY <br />
                      CUSTOMERS
                    </p>
                    <span
                      class="counterup__banner--items__number js-counter text-white"
                      data-count="80"
                    >
                      10,000<sup>+</sup>
                    </span>
                  </div>
                  <div class="counterup__banner--items text-center">
                    <p class="counterup__banner--items__text text-white">
                      MONTHLY <br />
                      ORDERS
                    </p>
                    <span
                      class="counterup__banner--items__number js-counter text-white"
                      data-count="70"
                    >
                    50<sup>+</sup>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

     <DynamicTestimonials />
   <Newsletter />
        <BrandLogos />
      </main>
    </>
  );
};

export default AboutUs;
